import axios from "axios";
import { DecryptToken } from "../../api/helpers/decrypt";

const token = DecryptToken();

const FabricType = async () => {
    const api = new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${process.env.REACT_APP_API_URL}/fabrictype/?paginate=false`,
            headers: {
                'Authorization': token
            }
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    }
    );

    try {
        const response = await api;
        return response;
    }
    catch (error) {
        console.error("FabricType error:", error.response || error);
        return [];
    }
};

export { FabricType };
